import { component } from "picoapp";
import choozy from "choozy";
import { remove, add, on } from "@selfaware/martha";

import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default component((node) => {
  let { btn } = choozy(node);

  if (btn) {
    on(btn, "click", () => {
      console.log("click");
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: `footer`,
          // offsetY: 75,
        },
        ease: "expo.out",
      });
    });
  }
});
